import { withInstall } from '@ll-plus/utils'

import Marquee from './src/marquee.vue'

export const LlMarqueePro = withInstall(Marquee)
export default LlMarqueePro
export * from './src/marquee'

declare module 'vue' {
  export interface GlobalComponents {
    LlMarqueePro: typeof Marquee
  }
}
